"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import axios from "axios";
// import request from "@/utils/request.js";
var _default = exports.default = {
  name: "Navs",
  components: {},
  props: {
    neednavs: {
      type: Boolean
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    projectName: {
      type: String,
      default: ""
    },
    matchType: {
      type: String,
      require: true
    },
    typeList: [Array]
  },
  data: function data() {
    return {
      inputdata: "",
      searchdata: "",
      // 专业列表
      arr: ["公共基础", "民族文化传承与创新", "财经商贸大类", "医药卫生大类", "电子信息大类", "装备制造大类", "教育与体育大类", "土木建筑大类", "交通运输大类", "文化艺术大类", "旅游大类", "农林牧渔大类", "食品药品与粮食大类", "公安与司法大类", "资源环境与安全大类", "能源动力与材料大类", "公共管理与服务大类", "生物与化工大类", "新闻传播大类", "轻工纺织大类", "水利大类"],
      // 类别列表
      arr1: ["全部", "国家级", "省级", "院校级"],
      arr2: ["第一届", "第二届"],
      active: "all",
      active1: 0,
      value: null
    };
  },
  methods: {
    getsearchdata: function getsearchdata() {
      this.$emit("setsearchdata", this.searchdata);
    },
    getinputdata: function getinputdata() {
      var inputdt = this.inputdata;
      this.$emit("setinputdata", inputdt);
    },
    changedate: function changedate(res) {
      var s = res.toString();
      var str = s.replace(/\s*/g, "");
      var year = str.substring(12, 8);
      this.$emit("changeyear", year);
    },
    // 专业大类
    // async getBookList() {
    //   const { data: res } = await axios.post("/course/getMajorList");
    //   if (res.status !== 200) {
    //     return this.$message.error("获取数据失败");
    //   }
    //   this.arr = res.data;
    // },
    // 项目类别
    // async getCategory() {
    //   const { data: res } = await request({
    //     url: "reception/course/getMatchesListByMatchType",
    //     type: "postQs",
    //     data: { matchType: this.matchType },
    //   });
    //   if (res.status !== 200) {
    //     return false;
    //   }
    //   res.data.unshift({
    //     id: null,
    //     matchName: "全部",
    //     matchType: "1000001669118673",
    //     matchYear: null,
    //   });
    //   this.arr1 = res.data;
    // },
    // 类别ID
    changeType: function changeType(i, item) {
      this.active1 = i;
      this.$emit("update:projectName", item.matchName);
      this.$emit("typeId", item.id);
      this.$emit("leibie", item.id);
    },
    // 专业ID
    changeId: function changeId(i, id) {
      this.active = i;
      this.$emit("majorId", id);
    },
    lookAtAll: function lookAtAll() {
      this.$emit("lookAtAll");
    }
  },
  created: function created() {
    // this.getBookList();
    // this.getCategory();
  },
  mounted: function mounted() {}
};